import React from 'react';
import '../../css/sticky-atc/StickyAtc.scss';
import {Spinner, TextField, Button} from "@shopify/polaris";

const StickyAtcCssEditor = ({ stickyAtc, changeText, save }) => {
    return <div>
        {stickyAtc.settings ? <div className="sticky-add-to-cart-css-editor">
            <TextField label="Custom CSS:" multiline={15} value={stickyAtc.settings.custom_css}
                       onChange={changeText('custom_css')} />
            <TextField label="Custom JS:" multiline={15} value={stickyAtc.settings.custom_js}
                       onChange={changeText('custom_js')} />
            <div className="save-button">
                <Button onClick={save} loading={stickyAtc.savingSettings} primary>Save</Button>
            </div>
        </div> : <div>
            <Spinner />
        </div>}
    </div>
};

export default StickyAtcCssEditor;
